import React from "react";
// import Resume from '../../assets/Resume.pdf';

const cta = () => {
    return (
        <div className="cta">
            <a href="https://www.linkedin.com/in/irinablumenfeld/" target="_blank" rel="noreferrer" className="btn">
                LinkedIn
            </a>
            {/* <a className="btn" href={Resume} download="Irina Blumenfeld Resume">Download Resume</a> */}
            <a className="btn-primary" href="#contact">Contact Me</a>
        </div>

    );
}

export default cta;